function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWidget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 512,
  height: 512,
  viewBox: "0 2 98 98"
}, props), /*#__PURE__*/React.createElement("linearGradient", {
  id: "widget_svg__a",
  x1: 49,
  x2: 49,
  y1: 95,
  y2: 10.429,
  gradientTransform: "matrix(1 0 0 -1 0 104)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#00efd1"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#00acea"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M63 38H35c-1.7 0-3 1.3-3 3s1.3 3 3 3h28c1.7 0 3-1.3 3-3s-1.3-3-3-3",
  style: {
    fill: "url(#widget_svg__a)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "widget_svg__b",
  x1: 49,
  x2: 49,
  y1: 95,
  y2: 10.429,
  gradientTransform: "matrix(1 0 0 -1 0 104)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#00efd1"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#00acea"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M63 50H35c-1.7 0-3 1.3-3 3s1.3 3 3 3h28c1.7 0 3-1.3 3-3s-1.3-3-3-3",
  style: {
    fill: "url(#widget_svg__b)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "widget_svg__c",
  x1: 49,
  x2: 49,
  y1: 95,
  y2: 10.429,
  gradientTransform: "matrix(1 0 0 -1 0 104)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#00efd1"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#00acea"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M63 62H35c-1.7 0-3 1.3-3 3s1.3 3 3 3h28c1.7 0 3-1.3 3-3s-1.3-3-3-3",
  style: {
    fill: "url(#widget_svg__c)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "widget_svg__d",
  x1: 49,
  x2: 49,
  y1: 95,
  y2: 10.429,
  gradientTransform: "matrix(1 0 0 -1 0 104)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#00efd1"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#00acea"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M49 12.8c-21.8 0-39.5 17.7-39.5 39.5 0 4.9.9 9.8 2.7 14.4 1.4 3.5 3.2 6.8 5.5 9.7L12.3 89c-.4 1-.3 2.2.4 3 .6.7 1.4 1.1 2.4 1.1h.5L36 89.6c4.1 1.5 8.4 2.2 13 2.2 21.8 0 39.5-17.7 39.5-39.5S70.8 12.8 49 12.8m0 73c-4.1 0-8-.7-11.6-2.1-.5-.2-1.1-.2-1.6-.2L20 86.3l3.9-9.2c.5-1.1.3-2.3-.5-3.1-2.4-2.7-4.3-5.9-5.7-9.4-1.5-3.9-2.3-8-2.3-12.2 0-18.5 15-33.5 33.5-33.5s33.5 15 33.5 33.5c.1 18.4-14.9 33.4-33.4 33.4",
  style: {
    fill: "url(#widget_svg__d)"
  }
}));
export { SvgWidget as ReactComponent };
export default "data:image/svg+xml;base64,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";